import {
  SET_LOANS, SET_CLOSED_LOANS, SET_TERM_DATA, SET_ACTIVE_TERMS
} from '../actions/loan'

const defaultState = {
  loans: null,
  total: 0,
  closedLoans: null,
  totalClosed: 0,
  termData: null,
  activeTerms: null,
}

const loanReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_LOANS: {
      const { data } = action
      return {
        ...state,
        loans: data.list,
        total: data.total,
      }
    }
    case SET_CLOSED_LOANS: {
      const { data } = action
      return {
        ...state,
        closedLoans: data.list,
        totalClosed: data.total,
      }
    }
    case SET_TERM_DATA: {
      const { data } = action
      return {
        ...state,
        termData: data,
      }
    }
    case SET_ACTIVE_TERMS: {
      const { data } = action
      return {
        ...state,
        activeTerms: data,
      }
    }

    default:
      return state
  }
}

export default loanReducer
